import React, { useCallback, useEffect, useState, useContext} from 'react'
import style from '../../../styles/mystyle.module.css'
import * as config from '../../../next.config.js'
import { Navbar } from '../Layout/Navbar'
import axios from "axios";
import TermsContext from '../../../context/Trems'
import { useRouter } from "next/router";
import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'next-i18next'
function Main({ callback }) {
  const callbackPolicy = useCallback(
    back => {

      callback(back)
    },
    []
  );
  const {t}=useTranslation("common")
  const router = useRouter();
  const vocabTerms = useContext(TermsContext)
  const [privacyPolicy, setprivacyPolicy] = useState([])
  const [loading, setLoading] = useState(true)
  const privacyPolicyRes = useQuery({ queryKey: ["privacy-policy"], queryFn: () => getPrivacyPolicy()})
  const getPrivacyPolicy = () => {

    let StatusIds = vocabTerms.statusIds
    let data = {
      // langId: router.locale,
      blogTypeCode: "privacy-policy",
      statusId: JSON.stringify(StatusIds),
      entityDetailsId: "0",
      cacheKey: "hakeem-privacy-policy"
    }
    return axios.get(`${config["basePath"]}/api/cms/blog/helpers/getBlogs`, {
      params: data,
      headers: {
        "Content-Type": "application/json",
        "accept-language": router.locale
      }
    })
      .then(resp => {
      
        if (resp.data.data.length > 0) {

          setprivacyPolicy(resp.data.data)
          callbackPolicy(resp.data.data)

          return resp.data.data
        }
      })
      .catch(function (error) {
        console.error(error);
      });

  }
  useEffect(() => {

    setLoading(false)
    let StatusIds = vocabTerms.statusIds

    let data = {
      // langId: router.locale,
      blogTypeCode: "privacy-policy",
      statusId: JSON.stringify(StatusIds),
      entityDetailsId: "0",
      cacheKey: "hakeem-privacy-policy"
    }
    axios
      .get(`${config["basePath"]}/api/cms/blog/helpers/checkForKeyIfExist`, {
        params: data
      }).then(off => {
      
      }).catch(err => console.log(err))
  }, [])
  return (
    <div className={style.ContainerMargin} style={{ backgroundColor: "white" }}>

      <Navbar showDownloadAppSection={false} exchangeAllCurrenciesCallBack={(res) => (res)} currenciesCallBack={(res) => (res)}>
        <div className={style.SectionContainer + " " + style.paddingTopContactandTermpage}>
          <div className={style.HeaderContact} >
            <div><img className={style.icontContact} src={`${config.basePath}/assest/Term.svg`} /></div>
            <div className={style.header4s2 + " " + style.Blod + " " + style.textaligncenter + " " + style.ColorBlack + " " + style.marginZero}  >{t("TermandCondition")}</div>
          </div>
        </div>
        <div className={style.SectionContainer}>
          <div className={style.allcard}>
            {privacyPolicyRes.isLoading == false ?

              <div className={style.SectionContainer}>
                <div className={style.allcard}>
                  {privacyPolicyRes.data && privacyPolicyRes.data.length > 0 ? privacyPolicyRes.data.map(x => x.transBlog[0]).map((i, index) => {
                    return <React.Fragment key={index}>
                      <div className={style.textaboutdoctor2 + " " + style.ColorBlack + " " + style.Blod + " " + style.paddingproduct} >
                        {i.title}
                      </div>
                      <div dangerouslySetInnerHTML={{ __html: i.body }} className={style.UlTerm} ></div>
                    </React.Fragment>
                  }) : ""}

                </div>
              </div>
              : ""}



          </div>
        </div>

      </Navbar>
    </div>
  )
}

export default Main
